var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"审核通过","confirmLoading":_vm.loading,"destroyOnClose":true},on:{"ok":_vm.save},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('a-form',{attrs:{"form":_vm.form}},[_c('a-form-item',{attrs:{"label":"平台额外补贴比例（仅可设置一次）"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'num',
          {
            rules: [
              { required: true, message: '请输入补贴比例' },
              {
                transform: val => +val,
                type: 'integer',
                message: '请输入整数'
              },
              {
                validator: _vm.numCheck
              }
            ]
          }
        ]),expression:"[\n          'num',\n          {\n            rules: [\n              { required: true, message: '请输入补贴比例' },\n              {\n                transform: val => +val,\n                type: 'integer',\n                message: '请输入整数'\n              },\n              {\n                validator: numCheck\n              }\n            ]\n          }\n        ]"}],attrs:{"addonAfter":"%","placeholder":"请填写0-50的整数"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }